export default import.meta.ROLLUP_FILE_URL_Q6sFPhEjCu2lh$w4VwLjaA